import {
  titleUI,
  descriptionUI,
  yesNoUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import {
  additionalBenefitsIntroDescription,
  additionalBenefitsIntroNote,
} from '../../content/additionalBenefits';

export default {
  uiSchema: {
    ...titleUI('Additional disability benefits'),
    ...descriptionUI(additionalBenefitsIntroDescription),
    'view:ancillaryFormsWizard': yesNoUI(
      'Do you want to answer questions to find out if you may be eligible for additional benefits?',
    ),
    'view:ancillaryFormsWizardNote': descriptionUI(additionalBenefitsIntroNote),
  },
  schema: {
    type: 'object',
    properties: {
      'view:ancillaryFormsWizard': { type: 'boolean' },
      'view:ancillaryFormsWizardNote': { type: 'object', properties: {} },
    },
  },
};
